export default "__VITE_ASSET__CHN90PiY__"